import { FC } from "react";
import { RepairmentViewForm } from "./RepairmentViewForm";

export const ViewModal: FC<{ uuid: string }> = ({ uuid }) => {
  return <RepairmentViewForm uuid={uuid} mode="modal" />;
};
